<template>
  <div>
    <vcl-facebook secondary="#ff9f43" v-if="loading"></vcl-facebook>
    <div v-if="!loading" class="vx-card">
      <div class="flex" style="height: 81vh;">
        <!-- soldan -->
        <div style="left: 0; width: 20%;">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex items-end px-3 mt-5">
                <feather-icon svgClasses="w-6 h-6" icon="FilterIcon" class="mr-2" />
                <span class="font-medium text-lg leading-none">Filtreler</span>
              </div>
              <vs-divider />
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/5">
              <div class="flex items-end px-3" style="margin-top: 20px;">
                Başlangıç
              </div>
            </div>
            <div class="vx-col md:w-3/5">
              <div class="flex items-end px-3 mt-5">
                <input style="height: 30px;" class="w-full" type="date" v-model="startDate" />
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/5">
              <div class="flex items-end px-3" style="margin-top: 20px;">
                Bitiş
              </div>
            </div>
            <div class="vx-col md:w-3/5">
              <div class="flex items-end px-3 mt-5">
                <input style="height: 30px;" class="w-full" type="date" v-model="finishDate" />
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/5">
              <div class="flex items-end px-3" style="margin-top: 25px;">
                Personel
              </div>
            </div>

            <div class="vx-col md:w-3/5">
              <div class="flex items-end px-3 mt-5">
                <v-select class="w-full" name="personnelSelect" placeholder="Personel Seçin" label="userName" :options="tempPersonnels" v-model="selectedPersonnel">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/5">
              <div class="flex items-end px-3" style="margin-top: 25px;">
                Müşteri Id
              </div>
            </div>

            <div class="vx-col md:w-3/5">
              <div class="flex items-end px-3 mt-5">
                <vs-input type="number" v-model="customerId" />
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/5">
              <div class="flex items-end px-3" style="margin-top: 25px;">
                Ülke
              </div>
            </div>

            <div class="vx-col md:w-3/5">
              <div class="flex items-end px-3 mt-5">
                <v-select class="w-full" name="country" placeholder="Ülke Seçiniz" label="value" :options="countries" v-model="selectedCountry">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/5">
              <div class="flex items-end px-3" style="margin-top: 25px;">
                İl
              </div>
            </div>

            <div class="vx-col md:w-3/5">
              <div class="flex items-end px-3 mt-5">
                <v-select class="w-full" name="county" placeholder="İl Seçiniz" label="value" :options="cities" v-model="selectedCity">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/5">
              <div class="flex items-end px-3" style="margin-top: 25px;">
                Bölge
              </div>
            </div>
            <div class="vx-col md:w-3/5">
              <div class="flex items-end px-3 mt-5">
                <v-select class="w-full" name="region" placeholder="Bölge Seçiniz" label="name" :options="regions" v-model="selectedRegion">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/5">
              <div class="flex items-end px-3" style="margin-top: 25px;">
                Ürün
              </div>
            </div>
            <div class="vx-col md:w-3/5">
              <div class="flex items-end px-3 mt-5">
                <vs-input type="number" class="w-full" size="large" v-model="productId" />
              </div>
            </div>
            <div class="vx-col md:w-1/5 mt-2" style="margin-left: -20px;">
              <div class="flex items-end px-3 mt-5">
                <feather-icon icon="SearchIcon" class="stoke-current cursor-pointer" @click.stop="productSearchPopupParent = true" />
                <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/5">
              <div class="flex items-end px-3" style="margin-top: 25px;">
                Marka
              </div>
            </div>
            <div class="vx-col md:w-3/5">
              <div class="flex items-end px-3 mt-5">
                <v-select class="w-full" name="brand" placeholder="Seçiniz" v-model="brand" :options="productBrandList" :clearable="true" :reduce="(productBrandList) => productBrandList.brandName" label="brandName">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/5">
              <div class="flex items-end px-3" style="margin-top: 25px;">
                Fatura
              </div>
            </div>
            <div class="vx-col md:w-3/5">
              <div class="flex items-end px-3 mt-5">
                <v-select class="w-full" placeholder="Seçiniz" label="value" :options="invoiceList" v-model="selectedInvoice">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mb-5 mr-2">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button type="border" color="warning" class @click="fetchReport">Görüntüle</vs-button>
                <export-to-excel :printOnExcel="JSON.parse(JSON.stringify(excelDataComputed))" v-if="report && excelFormat.length > 1"></export-to-excel>
              </div>
            </div>
          </div>
        </div>

        <!-- sağdan -->
        <div style="right: 0; width: 80%; border-left: 1px solid black;">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex items-end px-3 mt-5">
                <feather-icon svgClasses="w-6 h-6" icon="EyeIcon" class="mr-2" />
                <span class="font-medium text-lg leading-none">Personel Satış Raporu Oluştur</span>
              </div>
              <vs-divider />
            </div>
          </div>
          <vs-table v-if="report" search noDataText="Rapor yok" :data="report" pagination :max-items="15" maxHeight="57vh" class="px-2">
            <template slot="header">
              <div class="flex items-end items-center px-3"></div>
            </template>
            <template slot="thead">
              <vs-th>Satış ID</vs-th>
              <vs-th>Tarih</vs-th>
              <vs-th>Müşteri</vs-th>
              <vs-th>Ülke</vs-th>
              <vs-th>İl</vs-th>
              <vs-th>Bölge</vs-th>
              <vs-th>Bölge Durumu</vs-th>
              <vs-th>Satış Tipi</vs-th>
              <vs-th>Satış Durumu</vs-th>
              <vs-th>Fatura Tipi</vs-th>
              <vs-th>Ödeme Türü</vs-th>
              <vs-th>Para Birimi</vs-th>
              <vs-th>Vergi</vs-th>
              <vs-th>Cari</vs-th>
              <vs-th>Teslimat Türü</vs-th>
              <vs-th>Teknik ID</vs-th>
              <vs-th>Ürünler</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :stripe="true" v-for="(tr, i) in data" :key="i">
                <vs-td>{{ tr.saleOrderId }}</vs-td>
                <vs-td>
                  {{ tr.createdDate.replace("T", " ").substr(0, 16) }}
                </vs-td>
                <vs-td>{{ tr.customer }}</vs-td>
                <vs-td>{{ tr.country }}</vs-td>
                <vs-td>{{ tr.location }}</vs-td>
                <vs-td>{{ tr.region ? tr.region : "Girilmemiş" }}</vs-td>
                <vs-td>{{ tr.saleRegionDescription }}</vs-td>
                <vs-td>{{ tr.saleOrderType }}</vs-td>
                <vs-td>{{ tr.saleOrderStatus }}</vs-td>
                <vs-td>{{ tr.isFullInvoice ? "Faturalı" : "Faturasız" }}</vs-td>
                <vs-td>{{ tr.paymentType }}</vs-td>
                <vs-td>{{ tr.currency }}</vs-td>
                <vs-td>{{ tr.taxIncluded ? "KDVLI" : "KDVSIZ" }}</vs-td>
                <vs-td>{{ tr.customerBalance }}</vs-td>
                <vs-td>{{ tr.deliveryType }}</vs-td>
                <vs-td>{{ tr.technicId }}</vs-td>
                <vs-td>
                  <vs-table :data="tr.products">
                    <template slot="thead">
                      <vs-th>Ürün Adı</vs-th>
                      <vs-th>Adet</vs-th>
                      <vs-th>Fiyat</vs-th>
                    </template>

                    <template>
                      <vs-tr :key="i2" v-for="(tr2, i2) in tr.products">
                        <vs-td style="width: 80%;">{{ tr2.productName }}</vs-td>
                        <vs-td style="width: 10%;">
                          {{ tr2.productAmount }}
                        </vs-td>
                        <vs-td style="width: 10%;">
                          {{ tr2.priceDiscounted.toFixed(2) }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExportToExcel from "../../exportToExcel/exportToExcel.vue";

import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";
import { VclFacebook } from "vue-content-loading";
import ProductSearch from "../../Search/ProductSearch.vue";

export default {
  components: {
    vSelect,
    ExportToExcel,
    VclFacebook,
    ProductSearch,
  },

  data() {
    return {
      loading: true,

      tempPersonnels: [],
      personnels: [],
      teams: [],
      report: [].empty,
      excelFormat: [],
      selectedPersonnel: {}.empty,
      customerId: {}.empty,
      selectedTeam: {}.empty,
      cities: [],
      selectedCity: {}.empty,
      countries: [],
      selectedCountry: {}.empty,
      regions: [],
      selectedRegion: {}.empty,
      startDate: null,
      finishDate: null,
      productId: null,
      brand: null,
      productBrandList: [],
      brandSearch: { brandName: null },
      productSearchPopupParent: false,
      selectedInvoice: {}.empty,
      invoiceList: [
        { isFullInvoice: true, value: "Faturalı" },
        { isFullInvoice: false, value: "Faturasız" },
      ],
    };
  },

  computed: {
    excelDataComputed() {
      if (this.selectedPersonnel && this.selectedPersonnel.userName) {
        return {
          filename: this.excelFormat[0].AcilisTarihi.substr(0, 7) + " " + this.selectedPersonnel.userName + " satis raporu.xlsx",
          table: [...this.excelFormat],
        };
      }
      return {
        filename: this.excelFormat[0].AcilisTarihi.substr(0, 7) + " tüm personel satis raporu.xlsx",
        table: [...this.excelFormat],
      };
    },
  },

  methods: {
    reportFeaturesForExcel() {
      let tempData = JSON.parse(JSON.stringify(this.report));
      let totalPrice = 0;
      let names = "";
      let brand = "";
      let amount = 0;
      let productId = 0;
      let salePrice = 0;
      let salePriceCurrencyId = 0;
      let rowTotal = 0;
      let totalSalePrice = 0;
      this.excelFormat = [];
      for (let i = 0; i < tempData.length; i++) {
        
        if (tempData[i].saleOrderStatus != "Teklif") {
          if (tempData[i].products && tempData[i].products.length > 0)
            for (let j = 0; j < tempData[i].products.length; j++) {
              salePrice = parseFloat(tempData[i].products[j].SalePrice);
              salePriceCurrencyId = tempData[i].products[j].SalePriceCurrencyId;
              amount = tempData[i].products[j].productAmount;
              productId = tempData[i].products[j].productId;
              names += j + 1 + "-) " + tempData[i].products[j].productName + " (" + productId + ")  " + " (" + amount + " adet)   \n ";
              brand = tempData[i].products[j].brand;
              rowTotal += parseFloat((amount * tempData[i].products[j].priceDiscounted).toFixed(3));
              totalSalePrice = parseFloat((amount * tempData[i].products[j].SalePrice).toFixed(3));

              if (tempData[i].saleOrderStatus != "İptal") {
                totalPrice += parseFloat((tempData[i].products[j].priceDiscounted * amount * tempData[i].currencyValue * (tempData[i].taxIncluded ? 1.20 : 1)).toFixed(3));
              
              }
            }
            
          else {
            names += "Ürün yok!";
          }
          console.log("reyhan",tempData[i].saleOrderStatus);
          this.excelFormat.push({
            SatisId: tempData[i].saleOrderId,
            AcilisTarihi: tempData[i].createdDate.replace("T", " ").substr(0, 16),
            PersonelAdi: tempData[i].createdUser,
            MusteriId: tempData[i].customerId,
            MusteriAdi: tempData[i].customer,
            Ülke: tempData[i].country,
            İl: tempData[i].location,
            Bölge: tempData[i].region,
            BölgeDurumu: tempData[i].saleRegionDescription,
            TeslimatTuru: tempData[i].deliveryType,
            OdemeTuru: tempData[i].paymentType,
            SatisDurumu: tempData[i].saleOrderStatus,
            SatisTuru: tempData[i].saleOrderType,
            FaturaTipi: tempData[i].isFullInvoice ? "Faturalı" : "Faturasız",
            TeknikId: tempData[i].technicId,
            Vergi: tempData[i].taxIncluded ? "KDVLI" : "KDVSIZ",
            MusteriCari: tempData[i].customerBalance,
            UrunAdi: names,
            UrunFiyatVergisizToplam: rowTotal,
            SatisToplam: tempData[i].totalSalePrice,
            MusteriToplamTahsilat: tempData[i].customerTotalPayment,
            ParaBirimi: tempData[i].currency,
            Kur: tempData[i].currencyValue,
            TotalUsd: tempData[i].totalOwningCostUsd,
            TotalEuro: tempData[i].totalOwningCostEuro,
            TotalTL: tempData[i].totalOwningCostTl,
            TotalYuan: tempData[i].totalOwningCostYuan,
          });
        }
        names = "";
        rowTotal = 0;
        amount = 0;
      }
      this.excelFormat.push({
        GenelToplam: totalPrice,
      });
    },

    //excel için veriyi ayarlarken race condition dan kaçmaya çalsıyorum
    fetchReport: async function () {
      if (!this.startDate || !this.finishDate) {
        this.$vs.notify({
          title: "Hata!",
          text: "Tarih Kriterlerini Seçiniz",
          color: "danger",
        });
        return;
      }

      let postModel = {
        userId: this.selectedPersonnel ? this.selectedPersonnel.userId : "",
        countryId: this.selectedCountry ? this.selectedCountry.id : "",
        locationId: this.selectedCity ? this.selectedCity.id : "",
        regionId: this.selectedRegion ? this.selectedRegion.id : "",
        startDate: this.startDate,
        finishDate: this.finishDate,
        productId: this.productId,
        brand: this.brand,
        customerId: this.customerId ? this.customerId : "",
        isFullInvoice: this.selectedInvoice ? this.selectedInvoice.isFullInvoice : "",
      };
      this.$vs.loading();
      let r = await repository.postEntity("Reports/GetPersonnelReport", postModel);

      if (r && r.isSuccessful) {
        this.report = [].concat(r.list);
        this.report = repository.convertToJSON(this.report, "products");
        this.reportFeaturesForExcel();
        this.loading = false;
      } else {
        this.$vs.notify({
          title: "Hata Satış Listesi",
          text: (r && r.exceptionMessage && `${r.exceptionMessage} `) || "Bağlantı hatası",
          color: "danger",
        });
        this.loading = false;
      }
      this.$vs.loading.close();
    },

    findTeamMembers() {
      this.tempPersonnels = [];
      for (let i = 0; i < this.personnels.length; i++) {
        if (this.personnels[i].status == true) this.tempPersonnels.push(this.personnels[i]);
      }
    },
    getUsers: async function () {
      await repository.getAll("User/getUserList").then((r) => {
        this.personnels = r.list;
      });

      this.personnels = repository.convertToJSON(this.personnels, "userTeam");

      return this.personnels;
    },
    getCities: async function () {
      await repository.getAll("General/getCities").then((r) => {
        this.cities = r.list;
      });
      return this.cities;
    },
    getCountry: async function () {
      this.countries = await repository.getAll("General/getCountries").then((r) => r.list);
    },
    getRegion: async function () {
      await repository.getAll("General/getRegion").then((r) => {
        this.regions = r.list;
      });
      return this.regions;
    },
    getProductBrand: async function () {
      this.$vs.loading();
      this.productBrandList = await repository.postEntity("Product/GetProductBrand", this.brandSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    ProductSearchPopupClosedParent: async function (v) {
      this.productSearchPopupParent = false;
      if (v) {
        this.productId = v.productId;
      } else {
        this.productId = null;
      }
    },
  },
  created: async function () {
    let [a, b] = await Promise.all([this.getUsers(), this.getCities(), this.getRegion(), this.getCountry(), this.getProductBrand()]);
    if (a.length < 1 || b.length < 1) {
      this.$vs.notify({
        title: "Hata",
        text: "Bağlantı hatası",
        color: "danger",
        fixed: true,
      });
    } else {
      this.findTeamMembers();
      this.loading = false;
    }
  },
};
</script>
